"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockSubcatType = void 0;
function mockSubcatType(overrides = {}) {
    return {
        description: 'mock description',
        display_name: 'mock display_name',
        meta_description: 'mock meta_description',
        meta_title: 'mock meta_title',
        name: 'mock_subcategory_name',
        nav_hidden: false,
        page_heading: 'mock page_heading',
        page_subheading: 'mock page_subheading',
        slug: 'mock_url_path',
        ...overrides,
    };
}
exports.mockSubcatType = mockSubcatType;
